import { CircleHelp } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from 'ui';
import Button from 'ui/components/Button';
import { getIsBottomBarLoading, setHelpModalOpen } from '../../../store/uiSlice';
import { HelpModal } from '../../modals/help/help-modal';

export const Help = () => {
  const dispatch = useDispatch();
  const handleHelpClick = () => {
    dispatch(setHelpModalOpen(true));
  };
  const isBottomBarLoading = useSelector(getIsBottomBarLoading);

  return (
    <>
      {isBottomBarLoading ? (
        <>
          <Skeleton className="h-9 w-9 rounded-md" />
        </>
      ) : (
        <>
          <Button
            size="icon"
            variant="outline"
            leftIcon={<CircleHelp size={18} />}
            onClick={handleHelpClick}
            tooltip="Watch a quick tutorial on how to provide feedback"
            tooltipSide="top"
          ></Button>
          <HelpModal />
        </>
      )}

    </>
  );
};
